"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Mail, Phone, MapPin } from "lucide-react";
export default function WealthloopedFooter() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-secondary text-foreground pt-16 pb-8 px-6 md:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 justify-items-center mb-12">
          {}
          <div>
            <h3 className="text-base font-semibold mb-4 text-foreground text-center">Contact</h3>
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
              <Link to="mailto:investigation@assessmentwatch.com" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail size-4 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:f9y45h" data-ast-start="888" data-ast-end="947"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>investigation@assessmentwatch.com</Link>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin className="size-4 text-primary" aria-hidden="true" />
                228 Park Ave S PMB 517941 New York, New York 10003-1502
              </div>
              <Link to="tel:917-725-0540" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                <Phone className="size-4 text-primary" aria-hidden="true" />
                917-725-0540
              </Link>
            </div>
          </div>
        </div>

        {}
        
        <div className="flex justify-center items-center text-xs text-muted-foreground">
          <p>&copy; {currentYear} Assessment Watch. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}